import React, { useContext } from "react";
import Card from "../components/UI/Card";
import AuthContext from "../store/auth-context";
import classes from "./Home.module.css";
import logo from "../real-men-test-in-production.jpg";

const Home = (props) => {
  const AuthCtx = useContext(AuthContext);

  return (
    <Card>
      <h1 className={classes.home} onClick={AuthCtx.onLogout}>
        Home
      </h1>
      <img src={logo} className={`${classes.logomh} ${classes.center}`} alt="logo" />
    </Card>
  );
};

export default Home;